/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUpdateSalesInvoiceOrderNumberDto } from './CreateUpdateSalesInvoiceOrderNumberDto';
import {
    CreateUpdateSalesInvoiceOrderNumberDtoFromJSON,
    CreateUpdateSalesInvoiceOrderNumberDtoFromJSONTyped,
    CreateUpdateSalesInvoiceOrderNumberDtoToJSON,
} from './CreateUpdateSalesInvoiceOrderNumberDto';

/**
 * 
 * @export
 * @interface CreateUpdateSummarySalesInvoiceDto
 */
export interface CreateUpdateSummarySalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    currency?: CreateUpdateSummarySalesInvoiceDtoCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    status?: CreateUpdateSummarySalesInvoiceDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    paymentForm?: CreateUpdateSummarySalesInvoiceDtoPaymentFormEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    type?: CreateUpdateSummarySalesInvoiceDtoTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    invoiceDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    saleDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    payableDaysId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    printProjectNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    isPaymentFromReceiptDate?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    projectIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    isOnePositionOnInvoice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    onePositionName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    exchangeRate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    exchangeRateDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    gtuCodeId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    documentCodeIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    textOverItems?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    correctionReasonTxt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    correctionReasonDictId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    purchaserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    recipientClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    budgetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    approverId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    approvedTs?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    emailText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    emailSubject?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    toKsef?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    statusKsef?: CreateUpdateSummarySalesInvoiceDtoStatusKsefEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    numberKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    qrCodeKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    qrCodeKsefVerification?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    sentToSymphonyHandelTs?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    sentToSymphonyHandel?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    ksefDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    ksefRejectionReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    amountNet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    amountGross?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    amountNetDelta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    amountGrossDelta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    purchaserClientName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    purchaserClientAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    purchaserClientNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    recipientClientName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    recipientClientAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    recipientClientNip?: string | null;
    /**
     * 
     * @type {Array<CreateUpdateSalesInvoiceOrderNumberDto>}
     * @memberof CreateUpdateSummarySalesInvoiceDto
     */
    orderNumbers?: Array<CreateUpdateSalesInvoiceOrderNumberDto>;
}


/**
 * @export
 */
export const CreateUpdateSummarySalesInvoiceDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type CreateUpdateSummarySalesInvoiceDtoCurrencyEnum = typeof CreateUpdateSummarySalesInvoiceDtoCurrencyEnum[keyof typeof CreateUpdateSummarySalesInvoiceDtoCurrencyEnum];

/**
 * @export
 */
export const CreateUpdateSummarySalesInvoiceDtoStatusEnum = {
    Draft: 'Draft',
    Generated: 'Generated',
    Sent: 'Sent',
    InKseF: 'InKSeF',
    Paid: 'Paid'
} as const;
export type CreateUpdateSummarySalesInvoiceDtoStatusEnum = typeof CreateUpdateSummarySalesInvoiceDtoStatusEnum[keyof typeof CreateUpdateSummarySalesInvoiceDtoStatusEnum];

/**
 * @export
 */
export const CreateUpdateSummarySalesInvoiceDtoPaymentFormEnum = {
    BankTransfer: 'BankTransfer',
    Compensation: 'Compensation',
    Prepayment: 'Prepayment',
    Paid: 'Paid'
} as const;
export type CreateUpdateSummarySalesInvoiceDtoPaymentFormEnum = typeof CreateUpdateSummarySalesInvoiceDtoPaymentFormEnum[keyof typeof CreateUpdateSummarySalesInvoiceDtoPaymentFormEnum];

/**
 * @export
 */
export const CreateUpdateSummarySalesInvoiceDtoTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type CreateUpdateSummarySalesInvoiceDtoTypeEnum = typeof CreateUpdateSummarySalesInvoiceDtoTypeEnum[keyof typeof CreateUpdateSummarySalesInvoiceDtoTypeEnum];

/**
 * @export
 */
export const CreateUpdateSummarySalesInvoiceDtoStatusKsefEnum = {
    AcceptedInKseF: 'AcceptedInKSeF',
    RejectedInKseF: 'RejectedInKSeF',
    WaitingForKseF: 'WaitingForKSeF',
    Offline: 'OFFLINE'
} as const;
export type CreateUpdateSummarySalesInvoiceDtoStatusKsefEnum = typeof CreateUpdateSummarySalesInvoiceDtoStatusKsefEnum[keyof typeof CreateUpdateSummarySalesInvoiceDtoStatusKsefEnum];


/**
 * Check if a given object implements the CreateUpdateSummarySalesInvoiceDto interface.
 */
export function instanceOfCreateUpdateSummarySalesInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUpdateSummarySalesInvoiceDtoFromJSON(json: any): CreateUpdateSummarySalesInvoiceDto {
    return CreateUpdateSummarySalesInvoiceDtoFromJSONTyped(json, false);
}

export function CreateUpdateSummarySalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSummarySalesInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'paymentForm': !exists(json, 'paymentForm') ? undefined : json['paymentForm'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (new Date(json['invoiceDate'])),
        'saleDate': !exists(json, 'saleDate') ? undefined : (new Date(json['saleDate'])),
        'payableDaysId': !exists(json, 'payableDaysId') ? undefined : json['payableDaysId'],
        'printProjectNumber': !exists(json, 'printProjectNumber') ? undefined : json['printProjectNumber'],
        'isPaymentFromReceiptDate': !exists(json, 'isPaymentFromReceiptDate') ? undefined : json['isPaymentFromReceiptDate'],
        'projectIds': !exists(json, 'projectIds') ? undefined : json['projectIds'],
        'isOnePositionOnInvoice': !exists(json, 'isOnePositionOnInvoice') ? undefined : json['isOnePositionOnInvoice'],
        'onePositionName': !exists(json, 'onePositionName') ? undefined : json['onePositionName'],
        'exchangeRate': !exists(json, 'exchangeRate') ? undefined : json['exchangeRate'],
        'exchangeRateDescription': !exists(json, 'exchangeRateDescription') ? undefined : json['exchangeRateDescription'],
        'gtuCodeId': !exists(json, 'gtuCodeId') ? undefined : json['gtuCodeId'],
        'documentCodeIds': !exists(json, 'documentCodeIds') ? undefined : json['documentCodeIds'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'textOverItems': !exists(json, 'textOverItems') ? undefined : json['textOverItems'],
        'correctionReasonTxt': !exists(json, 'correctionReasonTxt') ? undefined : json['correctionReasonTxt'],
        'correctionReasonDictId': !exists(json, 'correctionReasonDictId') ? undefined : json['correctionReasonDictId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'purchaserId': !exists(json, 'purchaserId') ? undefined : json['purchaserId'],
        'recipientClientId': !exists(json, 'recipientClientId') ? undefined : json['recipientClientId'],
        'budgetId': !exists(json, 'budgetId') ? undefined : json['budgetId'],
        'approverId': !exists(json, 'approverId') ? undefined : json['approverId'],
        'approvedTs': !exists(json, 'approvedTs') ? undefined : (json['approvedTs'] === null ? null : new Date(json['approvedTs'])),
        'emailText': !exists(json, 'emailText') ? undefined : json['emailText'],
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
        'toKsef': !exists(json, 'toKsef') ? undefined : json['toKsef'],
        'statusKsef': !exists(json, 'statusKsef') ? undefined : json['statusKsef'],
        'numberKsef': !exists(json, 'numberKsef') ? undefined : json['numberKsef'],
        'qrCodeKsef': !exists(json, 'qrCodeKsef') ? undefined : json['qrCodeKsef'],
        'qrCodeKsefVerification': !exists(json, 'qrCodeKsefVerification') ? undefined : json['qrCodeKsefVerification'],
        'sentToSymphonyHandelTs': !exists(json, 'sentToSymphonyHandelTs') ? undefined : (json['sentToSymphonyHandelTs'] === null ? null : new Date(json['sentToSymphonyHandelTs'])),
        'sentToSymphonyHandel': !exists(json, 'sentToSymphonyHandel') ? undefined : json['sentToSymphonyHandel'],
        'ksefDate': !exists(json, 'ksefDate') ? undefined : (json['ksefDate'] === null ? null : new Date(json['ksefDate'])),
        'ksefRejectionReason': !exists(json, 'ksefRejectionReason') ? undefined : json['ksefRejectionReason'],
        'amountNet': !exists(json, 'amountNet') ? undefined : json['amountNet'],
        'amountGross': !exists(json, 'amountGross') ? undefined : json['amountGross'],
        'amountNetDelta': !exists(json, 'amountNetDelta') ? undefined : json['amountNetDelta'],
        'amountGrossDelta': !exists(json, 'amountGrossDelta') ? undefined : json['amountGrossDelta'],
        'purchaserClientName': !exists(json, 'purchaserClientName') ? undefined : json['purchaserClientName'],
        'purchaserClientAddress': !exists(json, 'purchaserClientAddress') ? undefined : json['purchaserClientAddress'],
        'purchaserClientNip': !exists(json, 'purchaserClientNip') ? undefined : json['purchaserClientNip'],
        'recipientClientName': !exists(json, 'recipientClientName') ? undefined : json['recipientClientName'],
        'recipientClientAddress': !exists(json, 'recipientClientAddress') ? undefined : json['recipientClientAddress'],
        'recipientClientNip': !exists(json, 'recipientClientNip') ? undefined : json['recipientClientNip'],
        'orderNumbers': !exists(json, 'orderNumbers') ? undefined : ((json['orderNumbers'] as Array<any>).map(CreateUpdateSalesInvoiceOrderNumberDtoFromJSON)),
    };
}

export function CreateUpdateSummarySalesInvoiceDtoToJSON(value?: CreateUpdateSummarySalesInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': value.currency,
        'number': value.number,
        'status': value.status,
        'paymentForm': value.paymentForm,
        'type': value.type,
        'invoiceDate': value.invoiceDate === undefined ? undefined : (value.invoiceDate.toISOString()),
        'saleDate': value.saleDate === undefined ? undefined : (value.saleDate.toISOString()),
        'payableDaysId': value.payableDaysId,
        'printProjectNumber': value.printProjectNumber,
        'isPaymentFromReceiptDate': value.isPaymentFromReceiptDate,
        'projectIds': value.projectIds,
        'isOnePositionOnInvoice': value.isOnePositionOnInvoice,
        'onePositionName': value.onePositionName,
        'exchangeRate': value.exchangeRate,
        'exchangeRateDescription': value.exchangeRateDescription,
        'gtuCodeId': value.gtuCodeId,
        'documentCodeIds': value.documentCodeIds,
        'active': value.active,
        'parentId': value.parentId,
        'textOverItems': value.textOverItems,
        'correctionReasonTxt': value.correctionReasonTxt,
        'correctionReasonDictId': value.correctionReasonDictId,
        'companyId': value.companyId,
        'purchaserId': value.purchaserId,
        'recipientClientId': value.recipientClientId,
        'budgetId': value.budgetId,
        'approverId': value.approverId,
        'approvedTs': value.approvedTs === undefined ? undefined : (value.approvedTs === null ? null : value.approvedTs.toISOString()),
        'emailText': value.emailText,
        'emailSubject': value.emailSubject,
        'toKsef': value.toKsef,
        'statusKsef': value.statusKsef,
        'numberKsef': value.numberKsef,
        'qrCodeKsef': value.qrCodeKsef,
        'qrCodeKsefVerification': value.qrCodeKsefVerification,
        'sentToSymphonyHandelTs': value.sentToSymphonyHandelTs === undefined ? undefined : (value.sentToSymphonyHandelTs === null ? null : value.sentToSymphonyHandelTs.toISOString()),
        'sentToSymphonyHandel': value.sentToSymphonyHandel,
        'ksefDate': value.ksefDate === undefined ? undefined : (value.ksefDate === null ? null : value.ksefDate.toISOString()),
        'ksefRejectionReason': value.ksefRejectionReason,
        'amountNet': value.amountNet,
        'amountGross': value.amountGross,
        'amountNetDelta': value.amountNetDelta,
        'amountGrossDelta': value.amountGrossDelta,
        'purchaserClientName': value.purchaserClientName,
        'purchaserClientAddress': value.purchaserClientAddress,
        'purchaserClientNip': value.purchaserClientNip,
        'recipientClientName': value.recipientClientName,
        'recipientClientAddress': value.recipientClientAddress,
        'recipientClientNip': value.recipientClientNip,
        'orderNumbers': value.orderNumbers === undefined ? undefined : ((value.orderNumbers as Array<any>).map(CreateUpdateSalesInvoiceOrderNumberDtoToJSON)),
    };
}

